// extracted by mini-css-extract-plugin
export default {"title_edit_modal":"EditCategoryModal_title_edit_modal__ZsP4h","input_edit_modal":"EditCategoryModal_input_edit_modal__e2c0H"};